import React, { useState, useEffect } from 'react';
// react library for routing
import { useLocation, NavLink as NavLinkRRD } from "react-router-dom";
// nodejs library that concatenates classes
import classnames from "classnames";
// nodejs library to set properties for components
import { PropTypes } from "prop-types";
// react library that creates nice scrollbar on windows devices
import PerfectScrollbar from "react-perfect-scrollbar";
// reactstrap components
import {
  Collapse,
  Navbar,
  NavItem,
  NavLink,
  Nav,
} from "reactstrap";

function Sidebar({ toggleSidenav, sidenavOpen, routes, rtlActive }) {
  const [state, setState] = useState({});
  const location = useLocation();
  React.useEffect(() => {
    setState(getCollapseStates(routes));
    // eslint-disable-next-line
  }, []);
  // verifies if routeName is the one active (in browser input)
  const activeRoute = (routeName) => {
    return location.pathname.indexOf(routeName) > -1 ? "" : "";
  };
  // makes the sidenav normal on hover (actually when mouse enters on it)
  const onMouseEnterSidenav = () => {
    if (!document.body.classList.contains("g-sidenav-pinned")) {
      document.body.classList.add("g-sidenav-show");
    }
  };
  // makes the sidenav mini on hover (actually when mouse leaves from it)
  const onMouseLeaveSidenav = () => {
    if (!document.body.classList.contains("g-sidenav-pinned")) {
      document.body.classList.remove("g-sidenav-show");
    }
  };
  // this creates the intial state of this component based on the collapse routes
  // that it gets through routes
  const getCollapseStates = (routes) => {
    let initialState = {};
    routes.map((prop, key) => {
      if (prop.collapse) {
        initialState = {
          [prop.state]: getCollapseInitialState(prop.views),
          ...getCollapseStates(prop.views),
          ...initialState,
        };
      }
      return null;
    });
    return initialState;
  };

  const wishes = () => {
    let hour = new Date().getHours()
    if (hour >= 22 && hour <= 23) {
      return 'לילה טוב';
    }
    else if (hour >= 0 && hour <= 4) {
      return 'לילה טוב';
    }
    else if (hour >= 5 && hour <= 11) {
      return 'בוקר טוב';
    }
    else if (hour >= 12 && hour <= 14) {
      return 'צהריים טובים';
    }
    else if (hour >= 15 && hour <= 18) {
      return 'אחר הצהריים טוב';
    }
    else if (hour >= 19 && hour <= 21) {
      return 'ערב טוב';
    }
    return 'אחים לנפש';
  };

  // this verifies if any of the collapses should be default opened on a rerender of this component
  // for example, on the refresh of the page,
  // while on the src/views/forms/RegularForms.js - route /admin/regular-forms
  const getCollapseInitialState = (routes) => {
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse && getCollapseInitialState(routes[i].views)) {
        return true;
      } else if (location.pathname.indexOf(routes[i].path) !== -1) {
        return true;
      }
    }
    return false;
  };
  // this is used on mobile devices, when a user navigates
  // the sidebar will autoclose
  const closeSidenav = () => {
    if (window.innerWidth < 1200) {
      toggleSidenav();
    }
  };

  useEffect(() => {
    if (window.innerWidth < 1200 && sidenavOpen) {
      toggleSidenav();
    }
  }, [])

  // this function creates the links and collapses that appear in the sidebar (left menu)
  const createLinks = (routes, term) => {
    return routes.map((prop, key) => {
      if (prop.redirect) {
        return null;
      }
      if (prop.layout !== '/app') {
        return null;
      }
      if (prop.menu !== term) {
        return null;
      }
      if (prop.collapse) {
        var st = {};
        st[prop["state"]] = !state[prop.state];
        return (
          <NavItem key={key}>
            <NavLink
              href="#pablo"
              data-toggle="collapse"
              aria-expanded={state[prop.state]}
              className={classnames({
                active: getCollapseInitialState(prop.views),
              })}
              onClick={(e) => {
                e.preventDefault();
                setState(st);
              }}
            >
              {prop.icon ? (
                <>
                  <i>{prop.icon}</i>
                  <span className="nav-link-text">{prop.name}</span>
                </>
              ) : prop.miniName ? (
                <>
                  <span className="sidenav-mini-icon"> {prop.miniName} </span>
                  <span className="sidenav-normal"> {prop.name} </span>
                </>
              ) : null}
            </NavLink>
            <Collapse isOpen={state[prop.state]}>
              <Nav className="nav-sm flex-column">
                {createLinks(prop.views, term)}
              </Nav>
            </Collapse>
          </NavItem>
        );
      }
      return (
        <NavItem className={activeRoute(prop.layout + prop.path)} key={key}>
          <NavLink
            to={prop.layout + prop.path}
            activeClassName=""
            onClick={closeSidenav}
            tag={NavLinkRRD}
          >
            {prop.icon !== undefined ? (
              <>
                <i>{prop.icon}</i>
                <span className="nav-link-text">{prop.name}</span>
              </>
            ) : prop.miniName !== undefined ? (
              <>
                <span className="sidenav-mini-icon"> {prop.miniName} </span>
                <span className="sidenav-normal"> {prop.name} </span>
              </>
            ) : (
              prop.name
            )}
          </NavLink>
        </NavItem>
      );
    });
  };

  const scrollBarInner = (
    <div className="scrollbar-inner">
      <div className="bg-light pb-2">
        <div className="sidenav-header d-flex align-items-center">
          <div className="w-100"></div>
          <div className="ml-auto">
            <div
              className={classnames("sidenav-toggler d-none d-xl-block", {
                active: sidenavOpen,
              })}
              onClick={toggleSidenav}
            >
              <div className="sidenav-toggler-inner">
                <i className="sidenav-toggler-line" />
                <i className="sidenav-toggler-line" />
                <i className="sidenav-toggler-line" />
              </div>
            </div>
          </div>
        </div>
        <div className="navbar-heading w-100">
          <h4 className="docs-normal m-0 p-0 text-center text-achim-black">{wishes()}</h4>
          <h4 className="docs-mini text-center text-achim-black"></h4>
        </div>
      </div>
      <div className="navbar-inner">
        <Collapse navbar isOpen={true}>
          {/* <Nav navbar>{createLinks(routes, 'app')}</Nav>
          <hr className="my-3" />
          <h6 className="navbar-heading p-0 text-muted">
            <span className="docs-normal">פעולות מהירות</span>
            <span className="docs-mini">פ</span>
          </h6>
          <Nav navbar>{createLinks(routes, 'action')}</Nav>
          <hr className="my-3" /> */}
          <h6 className="navbar-heading p-0 text-muted">
            <span className="docs-normal">ניהול</span>
            <span className="docs-mini">נ</span>
          </h6>
          <Nav navbar>{createLinks(routes, 'admin')}</Nav>
        </Collapse>
      </div>
    </div>
  );

  return (
    <Navbar
      className={
        "sidenav navbar-vertical navbar-expand-xs navbar-light bg-white " +
        (rtlActive ? "" : "fixed-left")
      }
      onMouseEnter={onMouseEnterSidenav}
      onMouseLeave={onMouseLeaveSidenav}
    >
      {navigator.platform.indexOf("Win") > -1 ? (
        <PerfectScrollbar>{scrollBarInner}</PerfectScrollbar>
      ) : (
        scrollBarInner
      )}
    </Navbar>
  );
}

Sidebar.defaultProps = {
  routes: [{}],
  toggleSidenav: () => { },
  sidenavOpen: false,
  rtlActive: true,
};

Sidebar.propTypes = {
  // function used to make sidenav mini or normal
  toggleSidenav: PropTypes.func,
  // prop to know if the sidenav is mini or normal
  sidenavOpen: PropTypes.bool,
  // links that will be displayed inside the component
  routes: PropTypes.arrayOf(PropTypes.object),
  // rtl active, this will make the sidebar to stay on the right side
  rtlActive: PropTypes.bool,
};

export default Sidebar;


/* <Nav className="mb-md-3" navbar>
  <NavItem>
    <NavLink
      href="https://demos.creative-tim.com/argon-dashboard-pro-react/#/documentation/overview?ref=adpr-sidebar"
      target="_blank"
    >
      <i className="ni ni-spaceship" />
      <span className="nav-link-text">Getting started</span>
    </NavLink>
  </NavItem>
  <NavItem>
    <NavLink
      href="https://demos.creative-tim.com/argon-dashboard-pro-react/#/documentation/colors?ref=adpr-sidebar"
      target="_blank"
    >
      <i className="ni ni-palette" />
      <span className="nav-link-text">Foundation</span>
    </NavLink>
  </NavItem>
  <NavItem>
    <NavLink
      href="https://demos.creative-tim.com/argon-dashboard-pro-react/#/documentation/alert?ref=adpr-sidebar"
      target="_blank"
    >
      <i className="ni ni-ui-04" />
      <span className="nav-link-text">Components</span>
    </NavLink>
  </NavItem>
  <NavItem>
    <NavLink
      href="https://demos.creative-tim.com/argon-dashboard-pro-react/#/documentation/charts?ref=adpr-sidebar"
      target="_blank"
    >
      <i className="ni ni-chart-pie-35" />
      <span className="nav-link-text">Plugins</span>
    </NavLink>
  </NavItem>
</Nav> */